import { loadStripe } from "@stripe/stripe-js";

declare const __BUILD_API_ORIGIN__: string;
declare const __BUILD_PUBLIC_URL__: string;
declare const __BUILD_GOOGLE_MAPS_API_KEY__: string;
declare const __BUILD_RECAPTCHA_SITE_KEY__: string;
declare const __BUILD_STRIPE_PUBLISHABLE_KEY__: string;

export const ENV = {
  API_ORIGIN: __BUILD_API_ORIGIN__ || "",
  PUBLIC_URL: __BUILD_PUBLIC_URL__ || "",
  GOOGLE_MAPS_API_KEY: __BUILD_GOOGLE_MAPS_API_KEY__ || "",
  RECAPTCHA_SITE_KEY: __BUILD_RECAPTCHA_SITE_KEY__ || "",
  STRIPE_PUBLISHABLE_KEY: __BUILD_STRIPE_PUBLISHABLE_KEY__ || "",
};

/** Initialized once at app load. Null if STRIPE_PUBLISHABLE_KEY is not configured. */
export const stripePromise = ENV.STRIPE_PUBLISHABLE_KEY
  ? loadStripe(ENV.STRIPE_PUBLISHABLE_KEY)
  : null;
